import { render, staticRenderFns } from "./promote-confirmation.vue?vue&type=template&id=455df558&scoped=true"
import script from "./promote-confirmation.vue?vue&type=script&lang=js"
export * from "./promote-confirmation.vue?vue&type=script&lang=js"
import style0 from "./promote-confirmation.vue?vue&type=style&index=0&id=455df558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455df558",
  null
  
)

export default component.exports